class SpecificationReadMore extends HTMLElement {
  constructor() {
    super();
    this.trigger = null;
    this.target = null;
    this.onTriggerClick = this.onTriggerClick.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector('.specification-read-more__trigger--more');
    this.target = document.getElementById('specifications');

    if (!this.trigger || !this.target) return;

    this.trigger.hidden = false;
    this.trigger.addEventListener('click', this.onTriggerClick);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.onTriggerClick);
  }

  onTriggerClick(event) {
    event.preventDefault();
    this.target.scrollIntoView({ behavior: 'smooth' });
  }
}

customElements.define('specification-read-more', SpecificationReadMore);
